// extracted by mini-css-extract-plugin
module.exports = {"content":"Uc","lookName":"Vc","shopTheLookContainer":"Wc","productContainer":"Xc","imageContainer":"Yc","mainImage":"Zc"};